import { ActionTree } from 'vuex';
import { RootState, dailyLottoState } from '@/types/store';

export const actions: ActionTree<dailyLottoState, RootState> = {
    actionSetDraws({ commit }, draws) {
        commit('SET_DRAWS', draws);
    },
    actionSetMarket({ commit }, markets) {
        commit('SET_MARKETS', markets);
    },
    actionAddToCart({ commit, state }, payload) {
        const cartClone = [...state.cartDaily];
        cartClone.push(...payload);
        commit('ADD_TO_CART', cartClone);
    },
    actionRemoveCart({ commit }, payload) {
        commit('REMOVE_TO_CART', payload);
    },
};

export default actions;
